<ng-container *transloco="let t">
@if (scenario) {
  <div class="w-100">
    <div class="row">
      <label class="col-sm-6 col-form-label" for="interest"
        >{{ t('portal.tasks.principalAndInterest') }}</label
      >
      <div class="col-sm-6">
        <input
          type="text"
          class="form-control"
          prefix="$ "
          mask="separator.2"
          thousandSeparator=","
          inputmode="decimal"
          [disabled]="true"
          name="principalAndInterest"
          [(ngModel)]="scenario.principalAndInterest"
        />
      </div>
    </div>
    <div class="row mt-1">
      <label class="col-sm-6 col-form-label" for="monthlyMi">{{ t('portal.tasks.monthlyMi') }}</label>
      <div class="col-sm-6">
        <input
          type="text"
          class="form-control"
          prefix="$ "
          mask="separator.2"
          thousandSeparator=","
          inputmode="decimal"
          [disabled]="true"
          name="monthlyMi"
          [(ngModel)]="scenario.monthlyMi"
        />
      </div>
    </div>
    <div class="row mt-1">
      <label class="col-sm-6 col-form-label" for="monthlyInsurance"
        >{{ t('portal.tasks.monthlyInsurance') }}</label
      >
      <div class="col-sm-6">
        <input
          type="text"
          class="form-control"
          prefix="$ "
          mask="separator.2"
          thousandSeparator=","
          inputmode="decimal"
          [disabled]="true"
          name="monthlyInsurance"
          [(ngModel)]="scenario.monthlyInsurance"
        />
      </div>
    </div>
    <div class="row mt-1">
      <label class="col-sm-6 col-form-label" for="monthlyTaxes"
        >{{ t('portal.tasks.monthlyTaxes') }}</label
      >
      <div class="col-sm-6">
        <input
          type="text"
          class="form-control"
          prefix="$ "
          mask="separator.2"
          thousandSeparator=","
          inputmode="decimal"
          [disabled]="true"
          name="monthlyTaxes"
          [(ngModel)]="scenario.monthlyTaxes"
        />
      </div>
    </div>
    <div class="row mt-1">
      <label class="col-sm-6 col-form-label" for="totalPayment"
        >{{ t('portal.tasks.totalPayment') }}</label
      >
      <div class="col-sm-6">
        <input
          type="text"
          class="form-control"
          prefix="$ "
          mask="separator.2"
          thousandSeparator=","
          inputmode="decimal"
          [disabled]="true"
          name="totalPayment"
          [(ngModel)]="scenario.totalPayment"
        />
      </div>
    </div>
  </div>
}
</ng-container>
